import { render, staticRenderFns } from "./StepsSection.vue?vue&type=template&id=c5a7223a&scoped=true&"
import script from "./StepsSection.vue?vue&type=script&lang=js&"
export * from "./StepsSection.vue?vue&type=script&lang=js&"
import style0 from "./StepsSection.vue?vue&type=style&index=0&id=c5a7223a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a7223a",
  null
  
)

export default component.exports